import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Loader from "react-loader";
import Modal from "react-awesome-modal";

import withServices from "src/HOCs/withServices";
import CustomNav from "../../../components/CustomNav/CustomNav.Component";
import DatePicker from "../../../components/DatePicker/DatePickerComponent";
import ScrollCard from "../../../components/Card/Card";
import {
  Container,
  Column,
  Row,
  DetailsWrapper,
  Detail,
} from "../ProfilePage.styles";
import { ChildrenList } from "../../Assessments/ParentAssessementResult.styles";
import {
  InputWrapper,
  FormWrapper,
  InputItemsRow,
  CtaWrapper,
} from "../../Onboard/Common/Common.styles";
import {
  isSubscriptionOwner,
  setProfileData,
} from "src/common/services";

interface Props {
  services: any;
  history: any;
  isStudent: boolean;
  isParent: boolean;
}

import DownloadLeanerReport from "../Student/DownloadLeanerReport.Component";
interface State {
  toLogin: boolean;
  fname: string;
  lname: string;
  currentpass: string;
  newpass: string;
  confirmpass: string;
  passmatch: boolean;
  currentfname: string;
  currentlname: string;
  subscriptionInfo: any;
  userProfile: any;
  userInfoLoaded: boolean;
  dob: string;
  email: string;
  children: any;
  childrenInfoLoaded: boolean;
  registerModalOpen: boolean;
  childfname: string;
  childlname: string;
  childDob: any;
  childEmail: string;
  dateObj: any;
  signupSuccess: boolean;
  feedbackModalOpen: boolean;
  avatar: any;
}

const assessmentDone = (val) => {
  if (val === "no") {
    return false;
  } else {
    return true;
  }
};

class ParentProfilePage extends Component<Props, State> {
  private avatarInputRef = React.createRef<HTMLInputElement>();
  constructor(props: Props) {
    super(props);

    this.state = {
      toLogin: false,
      fname: "",
      lname: "",
      dob: "",
      childfname: "",
      childlname: "",
      childEmail: "",
      childDob: "",
      dateObj: null,
      currentpass: "",
      newpass: "",
      confirmpass: "",
      passmatch: true,
      currentfname: "",
      currentlname: "",
      subscriptionInfo: null,
      userInfoLoaded: false,
      userProfile: null,
      email: "",
      children: null,
      childrenInfoLoaded: false,
      registerModalOpen: false,
      signupSuccess: false,
      feedbackModalOpen: false,
      avatar: null,
    };

    this.updatePasswordHandler = this.updatePasswordHandler.bind(this);
    this.updateProfileHandler = this.updateProfileHandler.bind(this);
    this.handleCancelSubscription = this.handleCancelSubscription.bind(this);
    this.addChild = this.addChild.bind(this);
    this.handleAvatarUpload = this.handleAvatarUpload.bind(this);
  }

  public async componentDidMount() {
    const {
      services: {
        adminAPI,
        parentsAPI,
        isUserLoggedIn,
        currentUserID,
      },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
    const userInfoRes = await adminAPI.fetchUserInfo();
    if (userInfoRes.ok) {
      const userInfo = userInfoRes.data;
      const subscriptionInfo = userInfo.subscription;
      const userProfile = userInfo.user_profile;
      this.setState({
        subscriptionInfo,
        userProfile,
        userInfoLoaded: true,
        fname: userInfo.first_name,
        lname: userInfo.last_name,
        dob: userInfo.user_profile.Profiledata.dob,
        email: userInfo.user_profile.User,
      });
    }
    const childrenRes = await parentsAPI.getChildren(currentUserID);
    if (childrenRes.ok) {
      this.setState({
        children: childrenRes.data.children,
        childrenInfoLoaded: true,
      });
    }
  }

  public updateSessionProfile = (newProfileData) => {
    setProfileData(newProfileData);
  };

  public onAvatarClickHandler = () => {
    const avatarUploader = this.avatarInputRef.current;
    if (avatarUploader) {
      avatarUploader.click();
    }
  };

  public async handleAvatarUpload(e) {
    const {
      services: { adminAPI },
    } = this.props;
    const formData = new FormData();
    formData.append("files", e.target.files[0]);
    const res = await adminAPI.updateAvatar(formData);
    if (res.ok) {
      toast.success(
        "Image successfully uploaded. It will appear in a few seconds."
      );
      setTimeout(() => this.fetchUserInfo(), 40000);
    } else {
      toast.error("Ooops, You cannot update your profile photo at this time!");
    }
  }

  public async fetchUserInfo() {
    const userInfoRes = await this.props.services.adminAPI.fetchUserInfo();
    if (userInfoRes.ok) {
      const userProfile = userInfoRes.data.user_profile;
      this.updateSessionProfile({
        ...userProfile.Profiledata,
        first_name: userInfoRes.data.first_name,
        last_name: userInfoRes.data.last_name,
      });
      this.setState({
        userProfile,
        fname: userInfoRes.data.first_name,
        lname: userInfoRes.data.last_name,
      });
    }
  }

  public async addChild(event) {
    event.preventDefault();
    const { childfname, childlname, childEmail, childDob } = this.state;
    const {
      services: { parentsAPI },
    } = this.props;
    const item = {
      first_name: childfname,
      last_name: childlname,
      email: childEmail,
      dob: childDob,
    };
    const addChildRes = await parentsAPI.addChild(item);
    if (addChildRes.ok) {
      toast.success("Congratulations on adding your child");
      this.setState({ signupSuccess: true, feedbackModalOpen: true });
    } else {
      toast.error("Failed!" + addChildRes.data.status);
      this.setState({ signupSuccess: false, feedbackModalOpen: true });
    }
  }

  public onLogout = () => {
    this.setState({ toLogin: true });
  };

  public ageChangeHandler = (dateObj) => {
    const childDob = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, childDob });
  };

  public handleChange = (field, e) => {
    if (field === "fname") {
      this.setState({ fname: e.target.value });
    }
    if (field === "childfname") {
      this.setState({ childfname: e.target.value });
    }
    if (field === "lname") {
      this.setState({ lname: e.target.value });
    }
    if (field === "childlname") {
      this.setState({ childlname: e.target.value });
    }
    if (field === "childemail") {
      this.setState({ childEmail: e.target.value });
    }
    if (field === "currentpass") {
      this.setState({ currentpass: e.target.value });
    }
    if (field === "newpass") {
      this.setState({ newpass: e.target.value });
    }
    if (field === "confirmpass") {
      const { newpass, confirmpass } = this.state;
      this.setState({
        confirmpass: e.target.value,
        passmatch: newpass === e.target.value,
      });
    }
  };
  public toggleRegisterChild = () => {
    const { registerModalOpen } = this.state;
    this.setState({ registerModalOpen: !registerModalOpen });
  };

  public async updatePasswordHandler() {
    const {
      services: { adminAPI },
    } = this.props;
    const { newpass, currentpass, confirmpass } = this.state;

    if (newpass === confirmpass && newpass !== "") {
      const item = {
        new_password: newpass,
        old_password: currentpass,
      };
      const res = await adminAPI.updatePassword(item);
      if (res.status === 200) {
        toast.success("Password Change Successful");
      } else if (res.status === 400) {
        toast.error("Your old password is incorrect");
      }
    } else {
      this.setState({ passmatch: false });
    }
  }

  public async updateProfileHandler() {
    const {
      services: { adminAPI },
    } = this.props;
    const { currentfname, currentlname, fname, lname, dob } = this.state;
    const item = {
      first_name: fname,
      last_name: lname,
      dob,
    };
    if (fname !== currentfname || lname !== currentlname) {
      const res = await adminAPI.updateUserProfileInfo(item);
      if (res.ok) {
        toast.success("Profile Updated!");
        this.fetchUserInfo();
      } else {
        toast.error("Sorry, profile could not be updated, try again");
      }
    }
  }
  public async handleCancelSubscription() {
    const {
      services: { parentsAPI },
    } = this.props;
    const cancelRes = await parentsAPI.cancelSubscription();
    if (cancelRes.ok) {
      toast.success("Subscription cancelled successfully");
    }
  }
  public onUpdateSubscription = () => {
    const {
      history,
      services: { currentBaseUrl },
    } = this.props;
    history.push(`${currentBaseUrl}updatesubscription`);
  };

  public renderProfileImage = () => {
    const { userInfoLoaded, userProfile, fname, lname } = this.state;
    if (userInfoLoaded) {
      return (
        <Column width="100%" height="200px" background={true}>
          <Row width="100%" height="100%">
            <div className="profile-left">
              <div className="avatar-wrapper">
                {this.props.services.currentAvatar === "" ? (
                  <i
                    className="fa fa-user-user"
                    aria-hidden="true"
                    onClick={this.onAvatarClickHandler}
                  />
                ) : (
                  <img
                    style={{ borderRadius: "30%" }}
                    src={`${this.props.services.currentAvatar}`}
                    onClick={this.onAvatarClickHandler}
                  />
                )}
                <input
                  style={{ display: "none" }}
                  ref={this.avatarInputRef}
                  onChange={this.handleAvatarUpload}
                  type="file"
                  accept="image/*"
                />
              </div>
              <p className="upload-prompt" onClick={this.onAvatarClickHandler}>
                Upload an image
              </p>
            </div>
            <div className="avatar-details">
              <h1>
                {fname} &nbsp; {lname}
              </h1>
              <h2>{userProfile.User}</h2>
            </div>
          </Row>
        </Column>
      );
    } else {
      return <Loader />;
    }
  };

  public renderUserDetails = () => {
    const { email, userInfoLoaded } = this.state;

    if (userInfoLoaded) {
      return (
        <React.Fragment>
          <Column width="100%" height="340px" background={true}>
            <h1 className="details-heading" style={{ marginTop: "-1.75em" }}>
              Update your Details
            </h1>
            <DetailsWrapper>
              <InputWrapper width="48%">
                <p>First Name</p>
                <input
                  type="text"
                  id="first-name"
                  className="custom-textfield"
                  placeholder="First Name"
                  required={true}
                  data-arg="first-name"
                  value={this.state.fname}
                  onChange={this.handleChange.bind(this, "fname")}
                />
              </InputWrapper>
              <InputWrapper width="48%">
                <p>Last Name</p>
                <input
                  type="text"
                  id="last-name"
                  className="custom-textfield"
                  placeholder="Last Name"
                  required={true}
                  data-arg="last-name"
                  onChange={this.handleChange.bind(this, "lname")}
                  value={this.state.lname}
                />
              </InputWrapper>
            </DetailsWrapper>

            <InputWrapper>
              <p>Email Address</p>
              <input
                contentEditable={false}
                type="email"
                id="email"
                className="custom-textfield"
                placeholder="Your Email"
                required={true}
                data-arg="email"
                value={email}
                readOnly={true}
              />
            </InputWrapper>
            <button
              className="green-button update-details"
              onClick={this.updateProfileHandler}
            >
              Update Details
            </button>
          </Column>
        </React.Fragment>
      );
    } else {
      return (
        <Column>
          <Loader color="#acff24" loaded={userInfoLoaded} />
        </Column>
      );
    }
  };

  public renderChangePassword = () => {
    return (
      <Column width="100%" height="400px" background={true}>
        <h1 className="details-heading" style={{ marginTop: "-1.5em" }}>
          Change your password
        </h1>
        <InputWrapper>
          <p>Enter your current password</p>
          <input
            type="password"
            id="current-password"
            className="custom-textfield"
            placeholder="Enter your current password"
            required={true}
            data-arg="current-pass"
            onChange={this.handleChange.bind(this, "currentpass")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Enter a new password</p>
          <input
            type="password"
            id="new-password"
            className="custom-textfield"
            placeholder="Enter new password"
            required={true}
            data-arg="new-pass"
            onChange={this.handleChange.bind(this, "newpass")}
          />
        </InputWrapper>
        <InputWrapper>
          <p>Confirm your new password</p>
          <input
            type="password"
            id="confirm-password"
            className="custom-textfield"
            placeholder="Confirm your new password"
            required={true}
            data-arg="confirm-pass"
            onChange={this.handleChange.bind(this, "confirmpass")}
          />
        </InputWrapper>
        <p
          style={{
            display: this.state.passmatch ? "none" : "block",
            color: "#ff0033",
          }}
        >
          Passwords don't match
        </p>
        <button
          className="green-button update-details"
          onClick={this.updatePasswordHandler}
        >
          Update Password
        </button>
      </Column>
    );
  };

  public renderSubscriptionDetail = () => {
    const { userInfoLoaded, subscriptionInfo } = this.state;

    if (userInfoLoaded) {
      const today = new Date();
      const expiry = new Date(subscriptionInfo.NextPaymentDate);
      const daysLeft = Math.round(
        (expiry.getTime() - today.getTime()) / (1000 * 3600 * 24)
      );
      return (
        <Column width="100%" height="200px" background={true}>
          <h1 className="details-heading">Subscription Details</h1>
          <DetailsWrapper>
            <Detail>
              <h3>
                {subscriptionInfo.PackageName} {subscriptionInfo.Name}
              </h3>
            </Detail>
          </DetailsWrapper>
          {/* <p>You can change some subscription details below</p> */}
          <DetailsWrapper width="80%">
            <button
              className="update-details"
              onClick={this.handleCancelSubscription}
              style={{ color: "#fff", backgroundColor: "#acff2460" }}
            >
              Cancel Membership
            </button>
            <button
              className="green-button update-details"
              onClick={this.onUpdateSubscription}
              style={{ display: "none" }}
            >
              Upgrade
            </button>
          </DetailsWrapper>
        </Column>
      );
    } else {
      return <Loader color="#acff24" loaded={userInfoLoaded} />;
    }
  };

  public renderChildrenDetails = () => {
    const { children, childrenInfoLoaded } = this.state;
    if (childrenInfoLoaded) {
      const noChild = (
        <React.Fragment>
          <p className="no-child">Please add your child or children here </p>
        </React.Fragment>
      );

      const content = (
        <ScrollCard
          // className="hide-x children-list"
          scrollable={true}
          maxHeight={225}
          scrollJumpSize={50}
          hidePatternBg={true}
          children={children.map((child) => (
            <div
              className="child-entry"
              key={child.User}
              style={{
                backgroundColor: `${
                  assessmentDone(child.PreAssesmentDone) ? "#acff24" : "#ff0033"
                }`,
              }}
              title={`${
                assessmentDone(child.PreAssesmentDone)
                  ? "Assessment Done :-)"
                  : "Assessment Not Done!"
              }`}
            >
              <p className="child-name">
                {child.first_name === ""
                  ? `${child.User}`
                  : `${child.first_name} ${child.last_name}`}
              </p>
            </div>
          ))}
        />
      );
      return (
        <ChildrenList>
          <h3 className="label">Your Children Details</h3>
          {children.length > 0 ? content : noChild}
          <button className="new-child" onClick={this.toggleRegisterChild}>
            <span>
              <i className="fa fa-plus" />
              &nbsp;Add New Child
            </span>
          </button>
        </ChildrenList>
      );
    } else {
      return <Loader />;
    }
  };
  public renderChildRegisterModal = () => {
    const { registerModalOpen } = this.state;
    return (
      <Modal
        visible={registerModalOpen}
        effect="fadeInUp"
        onClickAway={this.toggleRegisterChild}
        width="600"
        height="500"
      >
        <Row>
          <FormWrapper width="100%">
            <i
              className="fa fa-times-circle-o close-modal"
              aria-hidden="true"
              onClick={this.toggleRegisterChild}
            />

            <form onSubmit={this.addChild}>
              <h2 className="form-header">REGISTER YOUR CHILD'S DETAILS</h2>

              <div className="fields-wrapper">
                <InputWrapper>
                  <p>1. What are your child's names?</p>
                  <InputItemsRow>
                    <input
                      className="custom-textfield checkout-input"
                      type="text"
                      name="firstName"
                      id="first-name"
                      placeholder="First Name"
                      // onChange={this.handleChange}
                      required={true}
                      data-arg="firstName"
                      onChange={this.handleChange.bind(this, "childfname")}
                    />

                    <input
                      className="custom-textfield checkout-input"
                      type="text"
                      name="lastName"
                      id="last-name"
                      placeholder="Last Name"
                      // onChange={this.handleChange}
                      required={true}
                      data-arg="lastName"
                      onChange={this.handleChange.bind(this, "childlname")}
                    />
                  </InputItemsRow>
                </InputWrapper>
                <InputWrapper>
                  <p>2. What is your child's email address?</p>
                  <input
                    type="text"
                    className="custom-textfield"
                    id="studentemail"
                    placeholder="Email Address"
                    required={true}
                    data-arg="studentemail"
                    onChange={this.handleChange.bind(this, "childemail")}
                  />
                </InputWrapper>

                <InputWrapper>
                  <p>3. How old is your child?</p>
                  <DatePicker
                    value={this.state.dateObj}
                    onChange={this.ageChangeHandler}
                  />
                </InputWrapper>
              </div>

              <CtaWrapper>
                <button className="register-parent green-button" type="submit">
                  ADD CHILD
                </button>
              </CtaWrapper>
            </form>
          </FormWrapper>
        </Row>
      </Modal>
    );
  };

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    return (
      <div style={{ width: "100vw", height: "100vh" }}>
        <ToastContainer />
        <CustomNav {...this.props} logoutParent={this.onLogout} />
        {this.renderChildRegisterModal()}
        <Container>
          <Row width="80%" height="auto" style={{ marginTop: "3em" }}>
            <Column width="50%">
              {this.renderProfileImage()}
              {this.renderUserDetails()}
              {this.renderChangePassword()}
            </Column>
            <Column width="50%">
              {this.props.isParent ? this.renderChildrenDetails() : ""}
              {isSubscriptionOwner() ? this.renderSubscriptionDetail() : ""}
              {this.props.isStudent ? <DownloadLeanerReport {...this.props} /> : ""}
            </Column>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withServices(ParentProfilePage);



// WEBPACK FOOTER //
// ./src/pages/Profile/Parent/ParentProfilePage.Component.tsx